import * as Sm2 from './sm2';

export { Sm2 };

export const suiteTypes = {
  Sm2: Sm2,
};
